import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

export default {
    props: {
        value: {
            type: Boolean
        }
    },
    created() {
        this.result = cloneDeep(this.defaultData);
    },
    data() {
        return {
            visiable: false,
            defaultData: {
                Customer: '', //客户名称
                Tel: '', //客户电话
                C_Name: '', //主联系人
                Agent_Status: '', //审核状态
                PassTimeStart: null, //审核时间
                PassTimeEnd: null,
                CreateTimeStart: null, //提交时间
                CreateTimeEnd: null,
                BusEmployee: '', //业务经理
                ApplyType: 1 //申请类型
            },
            result: null,
            applyTypes: [{
                    TypeName: "全部",
                    TypeValue: "-1"
                },
                {
                    TypeName: "待主管审核",
                    TypeValue: "0"
                },
                {
                    TypeName: "主管审核不通过",
                    TypeValue: "1"
                }, {
                    TypeName: "已转正",
                    TypeValue: "2"
                }, {
                    TypeName: "待财务审核",
                    TypeValue: "4"
                },
            ]
        };
    },
    computed: {
        customerLevelList() {
            return this.$store.state.customerLevelList;
        },
        customerSourceList() {
            return this.$store.state.customerSourceList;
        }
    },
    watch: {
        value(val) {
            this.visiable = val;
        },
        visiable(val) {
            this.$emit('input', val);
        }
    },
    methods: {
        getFormdata() {
            let formdata = cloneDeep(this.result);
            formdata.PassTimeStart = isDate(formdata.PassTimeStart) ? util.time2str(formdata.PassTimeStart.getTime(), 'short') : null;
            formdata.PassTimeEnd = isDate(formdata.PassTimeEnd) ? util.time2str(formdata.PassTimeEnd.getTime(), 'short') : null;
            formdata.CreateTimeStart = isDate(formdata.CreateTimeStart) ? util.time2str(formdata.CreateTimeStart.getTime(), 'short') : null;
            formdata.CreateTimeEnd = isDate(formdata.CreateTimeEnd) ? util.time2str(formdata.CreateTimeEnd.getTime(), 'short') : null;
            return formdata;
        },
        search() {
            let filterData = this.getFormdata();
            lg(filterData);
            this.$emit('search', filterData);
        },
        reset() {
            this.result = cloneDeep(this.defaultData);
            this.$emit('reset');
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/AgentAudit/components/complex-search/vm.js